import React from 'react'
import { render } from 'react-dom'
import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import {reducer as toastrReducer} from 'react-redux-toastr';
import thunk from 'redux-thunk';
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import ReduxToastr from 'react-redux-toastr'

import helpersMenuReducer from './_store/reducers/helpers/menu';
import helpersBlurReducer from './_store/reducers/helpers/blur';
import helpersCountriesStatesReducer from './_store/reducers/helpers/countriesstates';
import helpersNotificationsReducer from './_store/reducers/helpers/notifications';
import helpersDesignReducer from './_store/reducers/helpers/design';
import fetchingReducer from './_store/reducers/fetching';
import printingReducer from './_store/reducers/printing';
import tokenRestoreReducer from './_store/reducers/tokenRestore';
import appStartupReducer from './_store/reducers/appStartup';
import translationLoadReducer from './_store/reducers/translationLoad';
import authReducer from './_store/reducers/auth';
import defaultsReducer from './_store/reducers/defaults';
import calculatorSettingsCompanyReducer from './_store/reducers/calculator/settings/company';
import calculatorJobsReducer from './_store/reducers/calculator/jobs/jobs';
import calculatorJobsDefaultsReducer from './_store/reducers/calculator/jobs/defaults';
import calculatorJobReducer from './_store/reducers/calculator/jobs/job';
import calculatorMachinesReducer from './_store/reducers/calculator/machines/machines';
import calculatorMachinesDefaultsReducer from './_store/reducers/calculator/machines/defaults';
import calculatorMachineReducer from './_store/reducers/calculator/machines/machine';
import visualMessageReducer from './_store/reducers/visualMessage';
import { localeReducer, initialize } from 'react-localize-redux';

import { basename } from 'config'

import RestoreToken from './components/RestoreToken';

import './index.scss'

const rootReducer = combineReducers({
    helpersMenu: helpersMenuReducer,
    helpersBlur: helpersBlurReducer,
    helpersCountriesStates: helpersCountriesStatesReducer,
    helpersNotifications: helpersNotificationsReducer,
    helpersDesign: helpersDesignReducer,
    fetching: fetchingReducer,
    printing: printingReducer,
    visualMessage: visualMessageReducer,
    tokenRestore: tokenRestoreReducer,
    appStartup: appStartupReducer,
    translationLoad: translationLoadReducer,
    auth: authReducer,
    defaults: defaultsReducer,
    calculatorSettingsCompany: calculatorSettingsCompanyReducer,
    calculatorJobs: calculatorJobsReducer,
    calculatorJobsDefaults: calculatorJobsDefaultsReducer,
    calculatorJob: calculatorJobReducer,
    calculatorMachines: calculatorMachinesReducer,
    calculatorMachinesDefaults: calculatorMachinesDefaultsReducer,
    calculatorMachine: calculatorMachineReducer,
    toastr: toastrReducer,
    locale: localeReducer
});

/*const logger = store => {
    return next => {
        return action => {
            console.log('[Middleware] Dispatching', action);
            const result = next(action);
            console.log('[Middleware] next state', store.getState());
            return result;
        }
    }
};*/

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));
//store.dispatch(actionCreators.defaultsFetch());

export const availableLanguages = ['en', 'de', 'nl', 'es', 'fr', 'it', 'pt'];
store.dispatch(initialize(availableLanguages,{missingTranslationMsg: '-'}));

const renderApp = () => (
	<Provider store={store}>
        <RestoreToken />
	</Provider>
)

const root = document.getElementById('app')
render(renderApp(), root)


// WEBPACK FOOTER //
// ./src/index.js